import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbGlobalPhysicalPosition } from '@nebular/theme';
import { OrganizationUnitService } from '../../organization-unit/organization-unit.service';
import { DepartamentService } from '../../departament/departament.service';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { FormGroup, FormBuilder, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Endereco, NgxViacepService } from '@brunoc/ngx-viacep';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { GroupUserService } from '../../group-user/group-user.service';
import { TypeHiringUserService } from '../../type-hiring-user/type-hiring-user.service';
import { ModalityWorkUserService } from '../../modality-work-user/modality-work-user.service';

@Component({
  selector: 'ngx-user-dialog',
  templateUrl: 'user-dialog.component.html',
  styleUrls: ['user-dialog.component.scss'],
})
export class UserDialogComponent implements OnInit {

  dateSelected;
  admissionDate;
  userAddress: any = {};
  states: any[] = []
  selectedStates: any[];
  oldCep: string;
  haveUserAddress: boolean;

  registerForm: FormGroup;
  submitted = false;

  roles: any[] = [];
  public user: any = {};
  public userLeaderSelected: any[];
  public users;
  typeUserSelected: any[] = [];
  selectedItem: any[] = [];
  departaments: any[];
  departamentSelected: any[];
  permissions: any[];
  permissionsSelected: any[];
  modalities: any[];
  modalitiSelected: any[];
  dropdownSettings = {};
  dropdownSettingsHiring = {};
  dropdownSettingsUser = {};
  dropdownSettingsDefault = {};
  dropdownSettingsDepartament = {};
  public locates: any = [];
  public locateUserSelected = [];

  dropdownSettingsState: IDropdownSettings = {
    singleSelection: true,
    searchPlaceholderText: 'Localizar',
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
    itemsShowLimit: 3,
    noDataAvailablePlaceholderText: 'Nenhum registro encontrado',
  };

  dropdownSettingsUserGroup: IDropdownSettings = {
    singleSelection: false,
    searchPlaceholderText: 'Localizar',
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
    itemsShowLimit: 3,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Marcar Todos',
    unSelectAllText: 'Desmarcar Todos',
    noDataAvailablePlaceholderText: 'Nenhum registro encontrado',
  };

  public roleSelected = '';
  public companySelected = '';

  public parentId = '';

  public isRoleMaster: boolean = false;
  closeDropdownSelection = false;
  disabled = false;

  public typeContracts: any[] = []

  public typesHiring: any[] = [];

  today: Date = new Date();

  userGroupSelected: any[];
  userGroups: any[];

  constructor(private userService: UserService,
    private route: ActivatedRoute, private toastrService: NbToastrService, private router: Router,
    private organizationUnitService: OrganizationUnitService, private departamentService: DepartamentService,
    private localeService: BsLocaleService, private formBuilder: FormBuilder, private viacep: NgxViacepService,
    private userGroupService: GroupUserService, private typeHiringUserService: TypeHiringUserService,
    private modalityWorkUserService: ModalityWorkUserService) {
    this.localeService.use('pt-br');

    this.roles.push({ codeIndex: 'ROLE_ADMIN', description: 'Administrador' });
    this.roles.push({ codeIndex: 'ROLE_USER', description: 'Usuário' });
    this.roles.push({ codeIndex: 'ROLE_INDICATOR', description: 'Gestor' });
    this.roles.push({ codeIndex: 'ROLE_OKR', description: 'OKR' });
    this.roles.push({ codeIndex: 'ROLE_ADMIN_OKR', description: 'OKR Master' });

    this.parentId = this.route.snapshot.params.parentId;

    this.dropdownSettings = {
      selectAllText: 'Selecionar tudo',
      itemsShowLimit: 2,
      unSelectAllText: 'Deselecionar Tudo',
      idField: 'codeIndex',
      textField: 'description',
      searchPlaceholderText: 'Localizar',
      allowSearchFilter: true,
      closeDropDownOnSelection: this.closeDropdownSelection,
      noDataAvailablePlaceholderText: 'Nenhum registro encontrado',
    };


    this.dropdownSettingsHiring = {
      singleSelection: true,
      selectAllText: 'Selecionar tudo',
      unSelectAllText: 'Deselecionar Tudo',
      idField: 'id',
      textField: 'description',
      searchPlaceholderText: 'Localizar',
      allowSearchFilter: true,
      closeDropDownOnSelection: this.closeDropdownSelection,
      noDataAvailablePlaceholderText: 'Nenhum registro encontrado',
    };

    this.dropdownSettingsUser = {
      idField: 'id',
      textField: 'firstName',
      singleSelection: true,
      selectAllText: 'Selecionar tudo',
      searchPlaceholderText: 'Localizar',
      unSelectAllText: 'Deselecionar Tudo',
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: 'Nenhum registro encontrado',
    };

    this.dropdownSettingsDefault = {
      idField: 'id',
      textField: 'label',
      searchPlaceholderText: 'Localizar',
      singleSelection: true,
      selectAllText: 'Selecionar tudo',
      unSelectAllText: 'Deselecionar Tudo',
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: 'Nenhum registro encontrado',
    };

    this.dropdownSettingsDepartament = {
      idField: 'id',
      textField: 'description',
      singleSelection: true,
      selectAllText: 'Selecionar tudo',
      searchPlaceholderText: 'Localizar',
      unSelectAllText: 'Deselecionar Tudo',
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: 'Nenhum registro encontrado',
    };
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required],
      office: [],
      phoneNumber: [],
      linkedin: [],
      email: ['', [Validators.required, Validators.email]],
      permission: ['', Validators.required],
      cep: [],
      logradouro: [],
      number: [],
      bairro: [],
      cidade: [],
      complemento: [],
      estado: [],
    });

    this.registerForm.setValidators(this.addressValidator());

    this.getAll();
    this.getTypeContract();
    this.getTypeHiring();
    this.getModalities();
    this.getLocate();
    this.getDepartaments();
    this.getStateList();
    this.getUserGroups();
    this.getUser(this.parentId);
  }

  public addressValidator(): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      const cep = group.controls['cep'];
      const logradouro = group.controls['logradouro'];
      const number = group.controls['number'];
      const bairro = group.controls['bairro'];
      const cidade = group.controls['cidade'];
      const estado = group.controls['estado'];

      if (this.haveUserAddress) {
        cep.setValidators([Validators.required, Validators.minLength(8), Validators.maxLength(8)]);
        logradouro.setValidators([Validators.required]);
        number.setValidators([Validators.required]);
        bairro.setValidators([Validators.required]);
        cidade.setValidators([Validators.required]);
        estado.setValidators([Validators.required]);
      } else {
        cep.clearValidators();
        cep.setErrors(null);
        logradouro.clearValidators();
        logradouro.setErrors(null);
        number.clearValidators();
        number.setErrors(null);
        bairro.clearValidators();
        bairro.setErrors(null);
        cidade.clearValidators();
        cidade.setErrors(null);
        estado.clearValidators();
        estado.setErrors(null);
      }
      return;
    };
  }

  onSubmit() {
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }

    this.save();
  }

  getAll() {
    this.userService.queryLoginNotAndEditNot(this.user.id).toPromise().then(response => {
      this.users = response.body;
    });
  }

  public getLocate(): any {
    this.organizationUnitService.query().toPromise().then((result: any) => {
      if (result) {
        this.locates = [];
        result.body.forEach(element => {
          this.locates.push({ label: element.name, id: element.id });
        });
      }
    });
  }


  getDepartaments() {
    this.departamentService.query().toPromise().then((result: any) => {
      this.departaments = result.body;
    })
  }

  getModalities() {
    this.modalityWorkUserService.query().toPromise().then(result => {
      this.modalities = result.body;
    })
  }

  getTypeHiring() {
    this.typeHiringUserService.query().toPromise().then(result => {
      this.typesHiring = result.body;
    })
  };

  getTypeContract() {
    this.typeContracts = [];
    this.typeContracts.push({ codeIndex: 1, description: 'PJ' });
    this.typeContracts.push({ codeIndex: 2, description: 'CLT' });
  }

  getUser(parentId) {
    if (parentId === 'create') {
      this.user = {};
      this.permissionsSelected = [];
      this.userLeaderSelected = [];
      this.departamentSelected = [];
      this.locateUserSelected = [];
      this.typeUserSelected = [];
      this.userGroupSelected = [];
      this.getAll();
    } else {

      setTimeout(() => {
        this.userService.find(this.parentId).toPromise().then(response => {
          const user: any = response;
          this.permissionsSelected = [];
          if (user.authorities) {
            for (let x = 0; x < this.roles.length; x++) {
              const permission = this.roles[x];
              for (let index = 0; index < user.authorities.length; index++) {
                const auth = user.authorities[index];
                if (auth === permission.codeIndex) {
                  this.permissionsSelected.push(permission);
                }
              }
            }
          }

          this.userLeaderSelected = [];
          if (user.userLeader) {
            this.userLeaderSelected.push(user.userLeader);
          }

          this.departamentSelected = [];
          if (user.departament) {
            this.departamentSelected.push(user.departament);
          }

          this.modalitiSelected = [];
          if (user.modalityWork) {
            for (let x = 0; x < this.modalities.length; x++) {
              const type = this.modalities[x];
              if (user.modalityWork.id === type.id) {
                this.modalitiSelected.push(type);
              }
            }
          }

          this.typeUserSelected = [];
          if (user.typeHiringUser) {
            for (let x = 0; x < this.typesHiring.length; x++) {
              const type = this.typesHiring[x];
              if (user.typeHiringUser.id === type.id) {
                this.typeUserSelected.push(type);
              }
            }
          }

          this.locateUserSelected = [];
          if (user.organizationUnitDTO) {
            for (let i = 0; i < this.locates.length; i++) {
              const localte = this.locates[i];
              if (localte.id === user.organizationUnitDTO.id) {
                this.locateUserSelected.push(localte);
              }
            }
          }
          this.user = user;
          this.getAll();

          const pattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

          if (this.user.dateBirthday) {
            const arrayDate = this.user.dateBirthday.match(pattern);
            const dt = new Date(arrayDate[3], arrayDate[2] - 1, arrayDate[1]);
            this.dateSelected = dt;
          }

          if (this.user.dateAdmission) {
            const arrayDate = this.user.dateAdmission.match(pattern);
            const dt = new Date(arrayDate[3], arrayDate[2] - 1, arrayDate[1]);
            this.admissionDate = dt;
          }
        });

        this.userService.getUserAddress(this.parentId).toPromise().then((ud: any) => {
          this.userAddress = ud;
          this.selectedStates = [{ id: ud.state, text: ud.state }];
          this.oldCep = ud.zipCode;
          this.haveUserAddress = true;
        }).catch(() => {
          this.haveUserAddress = false;
        });

        this.userGroupService.queryByUserId(this.parentId).toPromise().then(resp => {
          this.userGroupSelected = resp.body;
        })

      }, 300);
    }
  }

  getUserGroups() {
    this.userGroupService.query().toPromise().then(response => {
      this.userGroups = response.body;
    });
  }

  createObjectUser() {
    this.user.userLeader = this.userLeaderSelected[0];
    this.user.departament = this.departamentSelected[0];
    if (this.typeUserSelected) {
      if (this.typeUserSelected[0]) {
        this.user.typeHiringUser = this.typeUserSelected[0];
      }
    }

    if (this.modalitiSelected) {
      if (this.modalitiSelected[0]) {
        this.user.modalityWork = this.modalitiSelected[0];
      }
    }

    if (this.locateUserSelected) {
      if (this.locateUserSelected[0]) {
        this.user.organizationUnitDTO = this.locateUserSelected[0];
      }
    }

    if (this.permissionsSelected != null) {
      const roles = [];
      this.roles.forEach(permission => {
        this.permissionsSelected.forEach(permissionSel => {
          if (permission.codeIndex === permissionSel.codeIndex) {
            roles.push(permission.codeIndex);
          }
        });
      });
      this.user.authorities = roles;
    }

    if (this.dateSelected) {
      const datestring = this.dateSelected.getDate() + '/' + (this.dateSelected.getMonth() + 1) + '/'
        + this.dateSelected.getFullYear();
      this.user.dateBirthday = datestring;
    } else {
      this.user.dateBirthday = this.dateSelected;
    }

    if (this.admissionDate) {
      const datestring = this.admissionDate.getDate() + '/' + (this.admissionDate.getMonth() + 1) + '/'
        + this.admissionDate.getFullYear();
      this.user.dateAdmission = datestring;
    } else {
      this.user.dateAdmission = this.admissionDate;
    }
  }

  save() {
    this.createObjectUser();
    this.userService.create(this.user).toPromise().then(result => {

      if (this.haveUserAddress) {
        this.userService.saveAddress(result.body.id, this.userAddress).toPromise().catch(err => {
          this.toastrService.show('Usuário', err.error,
            { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
        });
      } else {
        this.userService.deleteAddress(result.body.id).toPromise().catch(err => {
          this.toastrService.show('Usuário', err.error,
            { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
        });
      }

      if (this.userGroupSelected && this.userGroupSelected.length > 0) {
        this.userGroupService.saveByUserId(this.user.id, this.userGroupSelected).toPromise().catch(err => {
          this.toastrService.show('Usuário', err.error,
            { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
        });
      }

      this.toastrService.show('Usuário', 'Salvo com sucesso',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.goBack();
    }).catch(err => {
      this.toastrService.show('Usuário', err.error,
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    });
  }

  modelChanged(event) {
    if (event > this.today) {
      this.dateSelected = this.today;
    } else {
      this.dateSelected = event;
    }
  }

  modelAdmissionDateChanged(event) {
    if (event > this.today) {
      this.admissionDate = this.today;
    } else {
      this.admissionDate = event;
    }
  }

  loadCep = false;
  @ViewChild('inputNum', { static: false }) inputNum: ElementRef;

  modelZipCodeChanged(cep) {
    this.loadCep = true;
    if (cep.length == 8 && this.oldCep != cep) {
      this.viacep.buscarPorCep(cep).then((endereco: Endereco) => {
        this.userAddress.street = endereco.logradouro;
        this.userAddress.neighborhood = endereco.bairro;
        this.userAddress.city = endereco.localidade;
        this.userAddress.state = endereco.uf;
        this.selectedStates = [{ id: endereco.uf, text: endereco.uf }];
        if (endereco.complemento.length > 0) {
          this.userAddress.complement = endereco.complemento;
        }
        this.loadCep = false;
        this.oldCep = cep;
        this.inputNum.nativeElement.focus();
      }).catch(err => {
        this.loadCep = false;
      });
    }
  }

  goBack() {
    this.router.navigate(['pages/admin/user'])
      .then(() => {
        window.location.reload();
      });
  }

  getStateList() {
    this.states = [];
    this.states.push({ id: 'AC', text: 'AC' });
    this.states.push({ id: 'AL', text: 'AL' });
    this.states.push({ id: 'AP', text: 'AP' });
    this.states.push({ id: 'AM', text: 'AM' });
    this.states.push({ id: 'BA', text: 'BA' });
    this.states.push({ id: 'CE', text: 'CE' });
    this.states.push({ id: 'DF', text: 'DF' });
    this.states.push({ id: 'ES', text: 'ES' });
    this.states.push({ id: 'GO', text: 'GO' });
    this.states.push({ id: 'MA', text: 'MA' });
    this.states.push({ id: 'MT', text: 'MT' });
    this.states.push({ id: 'MS', text: 'MS' });
    this.states.push({ id: 'MG', text: 'MG' });
    this.states.push({ id: 'PA', text: 'PA' });
    this.states.push({ id: 'PB', text: 'PB' });
    this.states.push({ id: 'PR', text: 'PR' });
    this.states.push({ id: 'PE', text: 'PE' });
    this.states.push({ id: 'PI', text: 'PI' });
    this.states.push({ id: 'RJ', text: 'RJ' });
    this.states.push({ id: 'RN', text: 'RN' });
    this.states.push({ id: 'RS', text: 'RS' });
    this.states.push({ id: 'RO', text: 'RO' });
    this.states.push({ id: 'RR', text: 'RR' });
    this.states.push({ id: 'SC', text: 'SC' });
    this.states.push({ id: 'SP', text: 'SP' });
    this.states.push({ id: 'SE', text: 'SE' });
    this.states.push({ id: 'TO', text: 'TO' });
  }

}
